import { settingsMock } from "./consts";
import { Setting, UserSettings } from "./types";

type MockResponse = {
  ok: boolean;
  json: () => Promise<UserSettings>;
  text: () => Promise<string>;
};

export const fetchChatSettings = async (
  functionKey: string,
  username: string
): Promise<Response | MockResponse> => {
  const requestBody = { user: username };

  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return {
      ok: true,
      json: async () => settingsMock,
      text: async () => JSON.stringify(settingsMock),
    };
  }

  const apiRequest = process.env.REACT_APP_SETTINGS_URL + functionKey;
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestBody),
  });
  return response;
};

type UpsertSettingsResponse = {
  ok: boolean;
  text: () => Promise<string>;
};

export const upsertSettings = async (
  functionKey: string,
  username: string,
  settings: Setting[]
): Promise<UpsertSettingsResponse> => {
  const requestBody = {
    user: username,
    settings: settings,
  };

  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return {
      ok: true,
      text: async () => "Mocked: User settings updated successfully.",
    };
  }
  const apiRequest = process.env.REACT_APP_UPSERT_SETTINGS_URL + functionKey;
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestBody),
  });
  return response;
};
